/**
 * Export loadData calls from ducks modules of different containers
 */
import { loadData as AdminEditListingPageLoader } from './AdminEditListingPage/AdminEditListingPage.duck';
import { loadData as AuthenticationPageLoader } from './AuthenticationPage/AuthenticationPage.duck';
import { loadData as BookingsPageLoader } from './BookingsPage/BookingsPage.duck';
import { loadData as PaymentsPageLoader } from './PaymentsPage/PaymentsPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { loadData as HomePageLoader } from './HomePage/HomePage.duck';
import { setInitialValues as CheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
import {
  storeData,
  CHECKOUT_PAGE_SESSION_KEY,
} from './CheckoutPage/CheckoutPageSessionHelpers';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as GoogleCalendarSettingsPageLoader } from './GoogleCalendarSettingsPage/GoogleCalendarSettingsPage.duck';
import { loadData as DashboardPageLoader } from './DashboardPage/DashboardPage.duck';
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as MakeOfferPageLoader } from './MakeOfferPage/MakeOfferPage.duck';
import { loadData as ManageListingsPageLoader } from './ManageListingsPage/ManageListingsPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as RequestQuotePageLoader } from './RequestQuotePage/RequestQuotePage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';
import {
  loadData as TransactionPageLoader,
  setInitialValues as TransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';

/**
 * Same payload as CheckoutPage duck action, but persists orderData when the guest
 * is about to hit auth before checkout (see ListingPage handleSubmit).
 */
const checkoutSetInitialValues = (initialValues, saveToSessionStorage = false) => {
  if (saveToSessionStorage && typeof window !== 'undefined') {
    const { listing, orderData } = initialValues || {};
    storeData(orderData, listing, null, CHECKOUT_PAGE_SESSION_KEY);
  }
  return CheckoutPageInitialValues(initialValues);
};

const getPageDataLoadingAPI = () => {
  return {
    HomePage: {
      loadData: HomePageLoader,
    },
    AdminEditListingPage: {
      loadData: AdminEditListingPageLoader,
    },
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    BookingsPage: {
      loadData: BookingsPageLoader,
    },
    PaymentsPage: {
      loadData: PaymentsPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CheckoutPage: {
      setInitialValues: checkoutSetInitialValues,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    GoogleCalendarSettingsPage: {
      loadData: GoogleCalendarSettingsPageLoader,
    },
    DashboardPage: {
      loadData: DashboardPageLoader,
    },
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    MakeOfferPage: {
      loadData: MakeOfferPageLoader,
    },
    ManageListingsPage: {
      loadData: ManageListingsPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    RequestQuotePage: {
      loadData: RequestQuotePageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
    },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
  };
};

export default getPageDataLoadingAPI;
